import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {withRouter} from 'react-router'
import {Link} from 'react-router-dom'
import cs from 'classnames'
import moment from 'moment'
import Button from '@components/button'
// import SvgIcon from '@components/svg-icon'
import ydlogo from '@assets/img/ydlogo.png'
import './index.less'

const dayMap = {
  0: '周日',
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六',
}

const CockpitHeader = inject('store')(
  observer(({
    store,
    location,
    history,
  }) => {
    const {userInfo, userLogout} = store
    const [curTime, setCurTime] = useState(new Date())
    const [curWeather, setCurWeather] = useState({})
    const [curCity, setCurCity] = useState()
    const {
      pathname,
    } = location

    // 定时轮询当前时间
    function intervalTime() {
      setInterval(() => {
        setCurTime(new Date())
      }, 1000)
    }

    //查询现在所在位置城市
    function showCityInfo() { 
      //加载城市查询插件 
      AMap.service(["AMap.CitySearch"], function() { 
        //实例化城市查询类 
        var citysearch = new AMap.CitySearch(); 
        //自动获取用户IP，返回当前城市 
        citysearch.getLocalCity(function(status, result){ 
          if(status === 'complete' && result.info === 'OK'){ 
            if(result && result.city && result.bounds) {
              setCurCity(result.city)
            } 
          }else{ 
            console.log("您当前所在城市：" + result.info + ""); 
          } 
        }); 
      }); 
    }

    //查询当前位置城市天气信息
    function getWeather() {
      AMap.plugin('AMap.Weather', function() {
        //创建天气查询实例
        var weather = new AMap.Weather();
    
        //执行实时天气信息查询
        weather.getLive(curCity, function(err, data) {
          console.log(err, data);
          setCurWeather(data)
        });
      });
    }

    useEffect(() => {
      showCityInfo()
      intervalTime()
      getWeather()
    }, [curCity])

    const curYear = moment(curTime).format('YYYY.MM.DD')
    const curHour = moment(curTime).format('HH:mm:ss')
    const curDay = curTime.getDay()

    return (
      <div className="cockpit-title">
        {
          userInfo && (
            <div className="cockpit-logout">
              <Link to="/overview" className="back-to-control">返回控制台</Link>
              <span className="cockpit-header-sp">
                {userInfo.userName}
                <Button
                  className="login-out"
                  onClick={() => {
                    userLogout()
                    history.push('/login')
                  }}
                >
                  退出登录
                </Button>
              </span>
            </div>
          )
        }
        <div className="cockpit-title-name">
          <img src={ydlogo} alt="" className="img-logo" />
          {/* <SvgIcon fill="#fff" iconClass="logo" /> */}
          勇电智慧照明管理云平台
        </div>
        <div className="cockpit-tabs">
          <Link
            to="/cockpit/index"
            className={cs({
              "cockpit-tab-first": true,
              active: pathname.indexOf('/cockpit/index') > -1,
            })}
          >
            首页
          </Link>
          <Link
            to="/cockpit/lightControl"
            className={cs({
              "cockpit-tab-item": true,
              active: pathname.indexOf('/cockpit/lightControl') > -1,
            })}
          >
            智慧灯光
          </Link>
          <Link
            to="/cockpit/energyStatistics"
            className={cs({
              "cockpit-tab-item": true,
              active: pathname.indexOf('/cockpit/energyStatistics') > -1,
            })}
          >
            智慧强电
          </Link>
          <Link
            to="/cockpit/realtimeMonitor"
            className={cs({
              "cockpit-tab-item": true,
              active: pathname.indexOf('/cockpit/realtimeMonitor') > -1,
            })}
          >
            智慧安防
          </Link>
          <div className="time-box">
            <div className="time-pos-bg-color" />
            <div className="time-item">
              <div className="time-top">
                {curYear}  {dayMap[curDay]}
              </div>
              <div className="time-bottom">
                {curHour}
              </div>
            </div>
            <div className="time-line" />
            <div className="time-item">
              <div className="time-top">
                {curWeather.weather || '--'}
              </div>
              <div className="time-bottom">
                {curWeather.temperature || '--'}℃
              </div>
            </div>
            <div className="time-line" />
            <div className="time-item">
              <div className="time-top">
                中国
              </div>
              <div className="time-bottom">
                {curCity ? curCity.replace("市", "") : '--'}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  })
)

export default withRouter(CockpitHeader)